import React from 'react';
import Layout from "@/Shared/Layout";
import { InertiaLink, useForm, usePage } from '@inertiajs/inertia-react';
import LoadingButton from '@/Shared/LoadingButton';
import CategoryForm from '@/Pages/Categories/Assets/CategoryForm';

const Create = () => {
  const {data, setData, errors, post, processing} = useForm({
    category_title: '',
    page_title: '',
    short_title: '',
    relative_url: '',
    showonline: 0,
    make_visible: 0,
    def_image_logo: '',
    rank: 0,
    keywords: '',
    category_description: '',
    meta_description: '',
    start_date: '',
    expire_date: '',
    featured: ''
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('categories.store').url());
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('categories')}
          className="text-indigo-600 hover:text-indigo-700"
        >
         Categories
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Create
      </h1>

      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <CategoryForm errors={errors} data={data} setData={setData} />
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Create Category
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Create.layout = page => <Layout title="Create category" children={page}/>;

export default Create;
